import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-layout',
  templateUrl: './home-page-layout.component.html',
  styleUrls: ['./home-page-layout.component.scss']
})
export class HomePageLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
